import { NavigationCard } from "@/components/navigation-card";

export function ExploreGameGeneratorsCard() {
  return (
    <NavigationCard
      title="Explore Game Generators"
      splash="https://images.unsplash.com/photo-1588591795084-1770cb3be374?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NDM2NzN8MHwxfHNlYXJjaHwxfHxwdXp6bGV8ZW58MHwwfHx8MTc0NTUyMzEzMnww&ixlib=rb-4.0.3&q=80&w=200"
      description="Explore game generator templates created by other users."
      to="/explore-game-generators"
    />
  );
}
